const StreamScheduleTiles = document.querySelectorAll('.StreamSchedule');
if (StreamScheduleTiles) {
    StreamScheduleTiles.forEach((tile) => {
       if (tile.dataset.timestamp) {
           try {
               const date = new Date(parseInt(tile.dataset.timestamp));
               const DayElement = tile.querySelector('.DateTile-day');
               if (DayElement) {
                   DayElement.innerText = date.getDate();
               }
               const MonthElement = tile.querySelector('.DateTile-month');
               if (MonthElement) {
                   MonthElement.innerText = date.toLocaleString(window.PageLocale, {month: 'long'});
               }
               const TimeElement = tile.querySelector('.StreamSchedule-time');
               if (TimeElement) {
                   if (tile.dataset.end) {
                       const month = date.toLocaleString(window.PageLocale, {month: 'long'});
                       const day = date.getDate();
                       let ampm = 'AM';
                       let hours = date.getHours();
                       if (hours >= 12) {
                           ampm = 'PM';
                           if (hours > 12) {
                               hours -= 12;
                           }
                       }
                       const minutes = date.getMinutes();
                       const timezone = date.toLocaleString(window.PageLocale, {timeZoneName: 'shortGeneric'}).split(' ').pop();

                       const end = new Date(parseInt(tile.dataset.end));
                       const endMonth = end.toLocaleString(window.PageLocale, {month: 'long'});
                       const endDay = end.getDate();
                       let endAmpm = 'AM';
                       let endHours = end.getHours();
                       if (endHours > 12) {
                           endAmpm = 'PM';
                           endHours -= 12;
                       }
                       const endMinutes = end.getMinutes();
                       TimeElement.innerHTML = `<span>${month} ${day}, ${hours}:${minutes < 10 ? '0' : ''}${minutes}${ampm}</span><span>&mdash;</span><span>${endMonth} ${endDay}, ${endHours}:${endMinutes < 10 ? '0' : ''}${endMinutes}${endAmpm} ${timezone}</span>`;
                   } else {
                       let ampm = 'AM';
                       let hours = date.getHours();
                       if (hours > 12) {
                           ampm = 'PM';
                           hours -= 12;
                       }
                       const minutes = date.getMinutes();
                       const timezone = date.toLocaleString(window.PageLocale, {timeZoneName: 'shortGeneric'}).split(' ').pop();
                       TimeElement.innerHTML = `${hours}:${minutes < 10 ? '0' : ''}${minutes}${ampm} ${timezone}`;
                   }
               }
           } catch (e) {
               throw(e);
           }
       }
    });
}
